<template>
    <div class="dialog" id="delete-account-dialog" aria-hidden="true">
        <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
        <div
            role="dialog"
            class="dialog-content dialog-content--add"
            aria-labelledby="my-dialog-title"
            aria-describedby="my-dialog-description"
        >
            <button
                data-a11y-dialog-hide
                class="dialog-close"
                aria-label="Close this dialog window"
            >
                <img src="@/assets/icons/dialog-close.svg" width="24" height="24" alt="Dialog close" />
            </button>

            <div class="add-form__name">{{ $t('profile_settings.delete_account.confirm_delete') }}</div>
            <div class="add-form__controls">
            </div>
            <div class="dialog__buttons">
                <button class="dialog__button"
                        data-a11y-dialog-hide
                        @click.prevent
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                >{{ $t('profile_settings.delete_account.cancel') }}</button>
                <button class="dialog__button dialog__button--alt"
                        type="submit"
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                        @click.prevent="submitDeleteAccount"
                >
                    <template v-if="!sendingForm">
                        {{ $t('profile_settings.delete_account.delete') }}
                    </template>
                    <template v-else>
                        {{ $t('profile_settings.delete_account.deleting') }}
                    </template>
                </button>
            </div>

        </div>
    </div>


</template>

<script>
import {inject, onMounted, ref} from "vue";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";
import UserService from "@/services/user.service";
import {useI18n} from "vue-i18n";

export default {
    name: "deleteAccount",
    setup() {
        const addDialog = ref(),
            sendingForm = ref(false),
            userService = new UserService(),
            alert = inject('alert'),
            {t} = useI18n();


        onMounted(() => {
            addDialog.value = new A11yDialog(document.querySelector("#delete-account-dialog"));
        });

        async function submitDeleteAccount () {
            sendingForm.value = true;
            axios.delete(ApiHelper.getDeleteAccountUrl(), {
                headers: authHelper.authHeader(),
            })
                .then((result) => {
                    sendingForm.value = false;
                    addDialog.value.hide();
                    AlertHelper.show(alert,t('profile_settings.delete_account.success'));

                    setTimeout(() => {
                        userService.logout();
                    },2000)
                })
                .catch((error) => {
                    console.log(error);
                    sendingForm.value = false;
                    let errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                })
        }

        return {
            sendingForm,
            submitDeleteAccount
        }
    }
}
</script>

<style scoped>

</style>
